import React, { useEffect, useState } from 'react';
import { apiRequest } from '../../../service/apiRequest';
import {
    Table,
    Button,
    Flex,
    Breadcrumb,
    Form,
    message,
    Popconfirm,
    Space,
    Pagination,
    Switch,
    TableProps,
    Select,
    DatePicker,
    Input,
    Modal,
    Card,
    List,
    Row,
    Col
} from 'antd';
import { createStyles } from 'antd-style';
import { HomeOutlined, DeleteOutlined, EditOutlined, TruckOutlined, SnippetsOutlined, FileTextOutlined, TagOutlined, PrinterOutlined } from '@ant-design/icons';
import { theme } from 'antd';
import { showSuccess, showError } from '../../../components/errorHandler';
import type { PopconfirmProps, TableColumnsType } from 'antd';
import { useCurrentModule } from '../../../hooks/useCurrentModule';
import dayjs from 'dayjs';

import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import type { RangePickerProps } from 'antd/es/date-picker';
import { useSearchParams, useNavigate } from 'react-router-dom';





import { saveAs } from 'file-saver';

const { RangePicker } = DatePicker;
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

const { Option } = Select;


const useStyle = createStyles(({ css }) => ({
    customTable: css`
    .ant-table {
      &-container {
        .ant-table-body,
        .ant-table-content {
          scrollbar-width: thin;
          scrollbar-color: #eaeaea transparent;
        }
      }
    }
  `,
}));

interface Sale {
    sale_id: number;
    sale_type: string;
    sale_category: string;
    sale_invoice_no: string;
    sale_date: string;
    sale_total: number;
    sale_is_shipping: 'Y' | 'N';
    sale_pincode: number;
    sale_city: string;
    sale_state: string;
    sale_address: string;
    customer_first_name: string;
    customer_last_name: string;
    customer_mobile_no: string;
    sales_first_name: string;
    sales_last_name: string;
    sale_items?: SaleItem[];
}
interface SaleItem {
    sd_id: number;
    sd_sale_type: 'job' | 'product';
    sd_product_id: number;
    sd_qty: number;
    sd_sub_total: number;
    sd_unit: string;
    sd_item_group: string;
    product_name: string;
    tailor_first_name?: string;
    tailor_last_name?: string;
    [key: string]: any;
}

interface Sale {
    sale_id: number;
    sale_invoice_no: string;
    sale_items?: SaleItem[];
}

interface ModalProps {
    open: boolean;
    onClose: () => void;
    sale: Sale;
}


interface clientItem {
    ledger_id: number;
    ledger_first_name: string;
    ledger_last_name: string;
    ledger_mobile_no: string;
    ledger_company_name: string;
    // ledger_company_gst_no: string;

    // Additional keys returned from your API
    reference_phone?: string;
    reference_name?: string;
    handover_phone?: string;
    handover_name?: string;
    invoice_category?: string;
    sales_employee?: string;


    ledger_gstin: string;
    active_cart: string;
    sale_id: string;
}
const Billing: React.FC = () => {
    const navigate = useNavigate();
    const currentModule = useCurrentModule();

    const [searchParams, setSearchParams] = useSearchParams();

    const [sales, setSales] = useState<Sale[]>([]);
    const [filterType, setFilterType] = useState<string>('');
    const [filterDate, setFilterDate] = useState<string>('');
    const [searchName, setSearchName] = useState<string>('');
    const [searchMobile, setSearchMobile] = useState<string>('');
    const [searchInvoiceNo, setSearchInvoiceNo] = useState<string>('');
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

    const [clientItems, setClientItems] = useState<clientItem[]>([]);
    const [initialValues, setInitialValues] = useState<clientItem | null>(null);

    const [pagination, setPagination] = useState<{ current: number; pageSize: number; total: number }>({
        current: 1,
        pageSize: 10,
        total: 0,
    });

    const {
        token: { colorBgContainer, borderRadiusLG },
    } = theme.useToken();


    const [selectedSale, setSelectedSale] = useState<Sale | null>(null);
    const [showJobModal, setShowJobModal] = useState(false);
    const [showProductModal, setShowProductModal] = useState(false);

    const handleViewJob = (sale: Sale) => {
        setSelectedSale(sale);
        setShowJobModal(true);
    };

    const handleViewSale = (sale: Sale) => {
        setSelectedSale(sale);
        setShowProductModal(true);
    };


    const fetchSales = async (page = 1, limit = 10) => {
        try {
            const params = new URLSearchParams({
                page: page.toString(),
                limit: limit.toString(),
                sale_type: filterType,
                sale_date: filterDate,
                customer_name: searchName,
                mobile_no: searchMobile,
                invoice_no: searchInvoiceNo,
            });

            const response = await apiRequest<{ data: Sale[]; total: number }>({
                method: 'get',
                url: `get-all-billing?${params.toString()}`,
            });

            setSales(response.data);
            setPagination((prev) => ({
                ...prev,
                total: response.total,
                current: page,
                pageSize: limit,
            }));
        } catch {
            showError('Failed to fetch sales');
        }
    };


    useEffect(() => {
        fetchSales();
    }, []);

    const groupBy = <T, K extends keyof T>(array: T[], key: K): Record<string, T[]> => {
        return array.reduce((result, item) => {
            const groupKey = item[key] as unknown as string;
            if (!result[groupKey]) result[groupKey] = [];
            result[groupKey].push(item);
            return result;
        }, {} as Record<string, T[]>);
    };

    const handleTableChange: TableProps<Sale>['onChange'] = (pagination, filters, sorter) => {
    };

    const columnsModal = [
        {
            title: 'Product ID',
            dataIndex: 'sd_product_id',
            key: 'sd_product_id',
        },
        {
            title: 'Quantity',
            dataIndex: 'sd_qty',
            key: 'sd_qty',
        },
        {
            title: 'Amount',
            dataIndex: 'sd_amount',
            key: 'sd_amount',
        },
        {
            title: 'Discount',
            dataIndex: 'sd_discount',
            key: 'sd_discount',
        },
        {
            title: 'Sub Total',
            dataIndex: 'sd_sub_total',
            key: 'sd_sub_total',
        },
        // Add more columns as needed
    ];

    // invoice
    // const onInvoiceDownload = async () => {
    //     if (!selectedRowKeys.length) {
    //         message.error("Please select a row to download its invoice.");
    //         return;
    //     }

    //     if (selectedRowKeys.length > 1) {
    //         message.warning("Only the first selected row will be used.");
    //     }
    //     try {
    //         const response = await apiRequest<Blob>({
    //             method: 'post',
    //             url: '/download-invoice',
    //             data: {
    //                 sale_id: [selectedRowKeys[0]],
    //             },
    //             config: {
    //                 responseType: 'blob',  // ✅ fix here
    //             },
    //         });

    //         const blob = new Blob([response], { type: 'application/pdf' });
    //         const url = window.URL.createObjectURL(blob);

    //         const link = document.createElement('a');
    //         link.href = url;
    //         link.setAttribute('download', `tax_invoice.pdf`);
    //         document.body.appendChild(link);
    //         link.click();

    //         link.remove();
    //         window.URL.revokeObjectURL(url);

    //         message.success("Download started.");
    //     } catch (error) {
    //         console.error("Invoice download error:", error);
    //         message.error("Failed to download Invoice.");
    //     }
    // };

    const onInvoiceDownload = async (saleId: number) => {
        try {
            const response = await apiRequest<Blob>({
                method: 'post',
                url: '/download-invoice',
                data: {
                    sale_id: [saleId], // Still an array
                },
                config: {
                    responseType: 'blob',
                },
            });

            const blob = new Blob([response], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `tax_invoice_${saleId}.pdf`);
            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);

            message.success("Download started.");
        } catch (error) {
            console.error("Invoice download error:", error);
            message.error("Failed to download invoice.");
        }
    };




    // transport
    const onInvoiceTransportDownload = async () => {
        if (!selectedRowKeys.length) {
            message.error("Please select a row to download its invoice Transport.");
            return;
        }

        if (selectedRowKeys.length > 1) {
            message.warning("Only the first selected row will be used.");
        }
        try {
            const response = await apiRequest<Blob>({
                method: 'post',
                url: '/download-invoice-transport',
                data: {
                    sale_id: [selectedRowKeys[0]],
                },
                config: {
                    responseType: 'blob',  // ✅ fix here
                },
            });

            const blob = new Blob([response], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `tax_invoice_transport.pdf`);
            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);

            message.success("Download started.");
        } catch (error) {
            console.error("Invoice Transport download error:", error);
            message.error("Failed to download Invoice Transport.");
        }
    };


    // job Tailor
    const onTailorJobDownload = async () => {
        if (!selectedRowKeys.length) {
            message.error("Please select a row to download its Tailor Job.");
            return;
        }

        if (selectedRowKeys.length > 1) {
            message.warning("Only the first selected row will be used.");
        }
        try {
            const response = await apiRequest<Blob>({
                method: 'post',
                url: '/download-tailor-job',
                data: {
                    sale_id: [selectedRowKeys[0]],
                },
                config: {
                    responseType: 'blob',  // ✅ fix here
                },
            });

            const blob = new Blob([response], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `tailor_job.pdf`);
            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);

            message.success("Download started.");
        } catch (error) {
            console.error("Tailor Job download error:", error);
            message.error("Failed to download Tailor Job.");
        }
    };


    // job slip
    const onJobslipDownload = async () => {
        if (!selectedRowKeys.length) {
            message.error("Please select a row to download its Job slip.");
            return;
        }

        if (selectedRowKeys.length > 1) {
            message.warning("Only the first selected row will be used.");
        }
        try {
            const response = await apiRequest<Blob>({
                method: 'post',
                url: '/download-job-slip',
                data: {
                    sale_id: [selectedRowKeys[0]],
                },
                config: {
                    responseType: 'blob',  // ✅ fix here
                },
            });

            const blob = new Blob([response], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `job_slip.pdf`);
            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);

            message.success("Download started.");
        } catch (error) {
            console.error("Job slip download error:", error);
            message.error("Failed to download Job slip.");
        }
    };


    // job Tag
    const onJobTagDownload = async () => {
        if (!selectedRowKeys.length) {
            message.error("Please select a row to download its Job Tag.");
            return;
        }

        if (selectedRowKeys.length > 1) {
            message.warning("Only the first selected row will be used.");
        }
        try {
            const response = await apiRequest<Blob>({
                method: 'post',
                url: '/download-job-tag',
                data: {
                    sale_id: [selectedRowKeys[0]],
                },
                config: {
                    responseType: 'blob',  // ✅ fix here
                },
            });

            const blob = new Blob([response], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `job_tag.pdf`);
            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);

            message.success("Download started.");
        } catch (error) {
            console.error("Job tag download error:", error);
            message.error("Failed to download Job tag.");
        }
    };

    const handleEditClick = (record: Sale) => {
        navigate(`/pos/${record.sale_id}`, {
            state: {
                isEditMode: true,
                disableInputs: ['invoiceCategory', 'phone', 'firstName', 'lastName', 'company', 'gst', 'salesEmployee'], // Example input names
            },
        });
    };



    const YourProductModalComponent: React.FC<ModalProps> = ({ open, onClose, sale }) => {
        const productItems = sale.sale_items?.filter(i => i.sd_sale_type === 'product') || [];





        return (
            <Modal
                open={open}
                title={`Product Items - Invoice: ${sale.sale_invoice_no}`}
                onCancel={onClose}
                footer={null}
                width={800}
            >
                <Table
                    dataSource={productItems}
                    columns={columnsModal}
                    rowKey="sd_id"
                    pagination={false}
                    scroll={{ y: 300 }}
                />
            </Modal>
        );
    };

    const YourJobModalComponent: React.FC<ModalProps> = ({ open, onClose, sale }) => {
        const jobItems = sale.sale_items?.filter(i => i.sd_sale_type === 'job') || [];

        // Group by sd_item_group
        const groupedItems = groupBy(jobItems, 'sd_item_group');

        return (
            <Modal
                open={open}
                title={`Job Items - Invoice: ${sale.sale_invoice_no}`}
                onCancel={onClose}
                footer={null}
                width={800}
            >
                {Object.entries(groupedItems).map(([group, items]) => {
                    // Assuming customer info is same for all items in the group — take from first item or sale object
                    const customerName = sale.customer_first_name + ' ' + sale.customer_last_name;
                    const customerMobile = sale.customer_mobile_no;

                    return (
                        <Card
                            key={group}
                            title={`Group: ${group}`}
                            style={{ marginBottom: 16 }}
                        >
                            <p><strong>Customer Name:</strong> {customerName}</p>
                            <p><strong>Customer Mobile:</strong> {customerMobile}</p>

                            <List
                                itemLayout="horizontal"
                                dataSource={items}
                                renderItem={item => (
                                    <List.Item key={item.sd_id}>
                                        <List.Item.Meta
                                            title={`Job No: ${item.sd_manual_job_no}`}
                                            description={
                                                <>
                                                    <div><strong>Tailor Name:</strong> {item.sd_tailor_name}</div>
                                                    <div><strong>Measurement:</strong> {item.sd_measurement}</div>
                                                    <div><strong>Fabric Issued:</strong> {item.sd_fabric_issued}</div>
                                                    {/* add more item fields here */}
                                                </>
                                            }
                                        />
                                    </List.Item>
                                )}
                            />
                        </Card>
                    );
                })}
            </Modal>
        );
    };


    const columns: TableColumnsType<Sale> = [
        {
            title: 'Sale Info',
            key: 'sale_info',

            width: 230,
            render: (_, record) => (
                <div>
                    <div><strong>Invoice:</strong> {record.sale_invoice_no}</div>
                    <div><strong>Date:</strong> {dayjs(record.sale_date).format('DD-MM-YYYY hh:mm A')}</div>
                    <div><strong>Type:</strong> {record.sale_type}</div>
                    <div><strong>Category:</strong> {record.sale_category}</div>
                </div>
            ),
        },
        {
            title: 'Customer Details',
            key: 'customer_details',
            render: (_, record) => (
                <div>
                    <div><strong>Name:</strong>{record.customer_first_name + ' ' + record.customer_last_name}</div>
                    <div><strong>Mobile:</strong>{record.customer_mobile_no}</div>
                </div>
            ),
        },
        {
            title: 'Payment Details',
            dataIndex: 'payment_mode',
            key: 'payment_mode',
            render: (_, record) => (
                <div>
                    <div><strong>Total (₹):</strong> {record.sale_total}</div>
                </div>
            ),
        },
        {
            title: 'Shipping Details',
            key: 'shipping_details',
            render: (_, record) => (
                <>
                    <div>
                        <strong>Shipping :</strong> {record.sale_is_shipping === "Y" ? "Yes" : "No"}
                    </div>

                    {
                        record.sale_is_shipping === "Y" && (
                            <>
                                <div><strong>Address :</strong> {record.sale_address}</div>
                                <div><strong>State :</strong> {record.sale_state}</div>
                                <div><strong>City :</strong> {record.sale_city}</div>
                                <div><strong>Pincode :</strong> {record.sale_pincode}</div>
                            </>
                        )
                    }
                </>
            ),
        },
        {
            title: 'Sales Person',
            dataIndex: 'sales_first_name',
            key: 'sales_first_name',
            render: (_, record) => (
                <div>
                    <div>{record.sales_first_name + ' ' + record.sales_last_name}</div>
                </div>
            ),
        },
        {
            title: 'Sale And Job Details',
            key: 'sale_details',
            width: 230,
            render: (_, record) => {
                const hasJob = record.sale_items?.some(item => item.sd_sale_type === 'job');
                const hasProduct = record.sale_items?.some(item => item.sd_sale_type === 'product');

                if (!hasJob && !hasProduct) return null;

                return (
                    <Space>
                        {hasProduct && (
                            <Button onClick={() => handleViewSale(record)}>View Sale</Button>
                        )}
                        {hasJob && (
                            <Button onClick={() => handleViewJob(record)}>View Job</Button>
                        )}
                    </Space>
                );
            },
        },
        {
            title: 'Action',
            key: 'action',
            fixed: 'right',
            width: 250,
            render: (_, record) => (
                <Space>
                    {/* <Button onClick={() => handleView(record)}>View</Button>
                <Button onClick={() => handleEdit(record)}>Edit</Button> */}
                    <Button
                        onClick={() => handleEditClick(record)}
                    >
                        <EditOutlined style={{ fontSize: 24, marginBottom: 4 }} />
                    </Button>

                    <Button
                        icon={<PrinterOutlined style={{ fontSize: 24, margin: 4 }} />}
                        onClick={() => onInvoiceDownload(record.sale_id)}
                        type="primary"
                        style={{ width: "100%", margin: 10 }}
                    ></Button>
                </Space>
            ),
        },
    ];






    return (
        <>
            <Row>
                <Col span={24}>
                    <Breadcrumb style={{ display: 'inline-block', margin: 0 }}>
                        <Breadcrumb.Item href="/">
                            <HomeOutlined />
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>View Billing</Breadcrumb.Item>
                    </Breadcrumb>
                </Col>
            </Row>


            <Row style={{ margin: '10px 5px' }}>
                <Col span={24}>
                    <Flex gap="middle" style={{ marginBottom: 0 }} wrap>
                        <Select
                            placeholder="Select Sale Type"
                            style={{ width: 200 }}
                            onChange={(value) => setFilterType(value)}
                            allowClear
                            dropdownMatchSelectWidth={true}
                        >
                            <Option value="Online">Online</Option>
                            <Option value="Store">Store</Option>
                        </Select>

                        <RangePicker
                            onChange={(dates, dateStrings) => {
                                if (dates) setFilterDate(dateStrings.join(' - '));
                                else setFilterDate('');
                            }}
                            format="DD-MM-YYYY"
                        />

                        <Input
                            placeholder="Customer Name"
                            onChange={(e) => setSearchName(e.target.value)}
                            style={{ width: 200 }}
                        />

                        <Input
                            placeholder="Mobile No"
                            onChange={(e) => setSearchMobile(e.target.value)}
                            style={{ width: 200 }}
                        />

                        <Input
                            placeholder="Invoice No."
                            onChange={(e) => setSearchInvoiceNo(e.target.value)}
                            style={{ width: 200 }}
                        />

                        <Button style={{ display: 'flex', alignSelf: 'center' }} type="primary" onClick={() => fetchSales(1, pagination.pageSize)}>
                            Search
                        </Button>
                    </Flex>
                </Col>
            </Row>


            <Row gutter={[8, 16]} // Add spacing between buttons
                style={{
                    margin: '10px',
                    display: 'flex',
                    flexWrap: 'wrap', // Allow wrapping on small screens
                }}>
                <Col xs={24} sm={12} md={6} lg={3} style={{ margin: '0px 10px' }}>
                    <Button
                        type="primary"
                        size="large"
                        disabled={selectedRowKeys.length !== 1}
                        onClick={onInvoiceTransportDownload}
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                        }}
                    >
                        <TruckOutlined style={{ fontSize: 24, marginBottom: 4 }} />
                        <div style={{ textAlign: 'center', fontSize: 12, lineHeight: 1.2 }}>
                            Transport Print
                        </div>
                    </Button>
                </Col>

                <Col xs={24} sm={12} md={6} lg={3} style={{ margin: '0px 10px' }}>
                    <Button
                        type="primary"
                        size="large"
                        disabled={selectedRowKeys.length !== 1}
                        onClick={onTailorJobDownload}
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                        }}
                    >
                        <SnippetsOutlined style={{ fontSize: 24, marginBottom: 4 }} />
                        <div style={{ textAlign: 'center', fontSize: 12, lineHeight: 1.2 }}>
                            Job Tailor Print
                        </div>
                    </Button>
                </Col>

                <Col xs={24} sm={12} md={6} lg={3} style={{ margin: '0px 10px' }}>
                    <Button
                        type="primary"
                        size="large"
                        disabled={selectedRowKeys.length !== 1}
                        onClick={onJobslipDownload}
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                        }}
                    >
                        <FileTextOutlined style={{ fontSize: 24, marginBottom: 4 }} />
                        <div style={{ textAlign: 'center', fontSize: 12, lineHeight: 1.2 }}>
                            Job Slip Print
                        </div>
                    </Button>
                </Col>

                <Col xs={24} sm={12} md={6} lg={3} style={{ margin: '0px 10px' }}>
                    <Button
                        type="primary"
                        size="large"
                        disabled={selectedRowKeys.length !== 1}
                        onClick={onJobTagDownload}
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                        }}
                    >
                        <TagOutlined style={{ fontSize: 24, marginBottom: 4 }} />
                        <div style={{ textAlign: 'center', fontSize: 12, lineHeight: 1.2 }}>
                            Job Tag
                        </div>
                    </Button>
                </Col>
            </Row>






            <div
                style={{
                    minHeight: 360,
                    background: colorBgContainer,
                    borderRadius: borderRadiusLG,
                }}
            >
                <Table<Sale>
                    columns={columns}
                    dataSource={sales.slice(
                        (pagination.current - 1) * pagination.pageSize,
                        pagination.current * pagination.pageSize
                    )}
                    tableLayout="fixed"
                    rowKey="sale_id"
                    pagination={false}
                    onChange={handleTableChange}
                    bordered
                    rowSelection={{
                        selectedRowKeys,
                        onChange: setSelectedRowKeys,
                        type: 'checkbox',
                        columnWidth: 40,
                    }}
                    // scroll={{ y: 37 * 11 }}
                    scroll={{ x: 1400, y: 37 * 11 }}
                    locale={{ emptyText: 'No Voucher found' }}
                    footer={() => (
                        <Flex justify="space-between" style={{ marginTop: 16 }}>
                            <span>
                                Showing {(pagination.current - 1) * pagination.pageSize + 1}–
                                {Math.min(pagination.current * pagination.pageSize, pagination.total)} of {pagination.total}
                            </span>
                            <Pagination
                                current={pagination.current}
                                pageSize={pagination.pageSize}
                                total={pagination.total}
                                onChange={(page, size) => fetchSales(page, size)}
                                showSizeChanger
                            />
                        </Flex>
                    )}
                />
            </div>

            {showProductModal && selectedSale && (
                <YourProductModalComponent
                    open={showProductModal}
                    onClose={() => setShowProductModal(false)}
                    sale={selectedSale}
                />
            )}

            {showJobModal && selectedSale && (
                <YourJobModalComponent
                    open={showJobModal}
                    onClose={() => setShowJobModal(false)}
                    sale={selectedSale}
                />
            )}
        </>
    );
};

export default Billing;